<template>
  <div class="relative flex items-center w-full">
    <div
      v-if="$slots.leading"
      class="absolute left-3 z-10 flex items-center pointer-events-none text-gray-400"
    >
      <slot name="leading" />
    </div>

    <input
      v-bind="$attrs"
      :value="modelValue"
      :type="type"
      :placeholder="placeholder"
      :disabled="disabled"
      :required="required"
      class="w-full rounded-md bg-white dark:bg-[#1b2022] ring-1 ring-[#E4E4E4] dark:ring-[#384247] focus:outline-none focus:ring-1 focus:ring-[#f26998] dark:focus:ring-[#f26998] dark:focus:bg-[#2b3236] font-semibold text-sm text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 disabled:opacity-60 disabled:cursor-not-allowed transition-shadow"
      :class="[
        sizeClass,
        $slots.leading ? 'pl-9' : 'pl-3',
        $slots.trailing ? 'pr-9' : 'pr-3',
      ]"
      @input="
        $emit('update:modelValue', ($event.target as HTMLInputElement).value)
      "
    />

    <div
      v-if="$slots.trailing"
      class="absolute right-3 z-10 flex items-center text-gray-400"
    >
      <slot name="trailing" />
    </div>
  </div>
</template>

<script setup lang="ts">
  defineOptions({ inheritAttrs: false })

  const props = defineProps({
    modelValue: {
      type: [String, Number],
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    placeholder: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: "md",
    },
    // Legacy props accepted but unused (kept for API compatibility)
    color: { type: String, default: null },
    loading: { type: Boolean, default: false },
    padded: { type: Boolean, default: true },
    variant: { type: String, default: null },
    ui: { type: Object, default: null },
  })

  defineEmits(["update:modelValue"])

  const sizeClass = computed(() => {
    const sizes: Record<string, string> = {
      xs: "py-1 text-xs",
      sm: "py-1.5 text-sm",
      md: "py-2 text-sm",
      lg: "py-2.5 text-base",
      xl: "py-3 text-base",
    }
    return sizes[props.size] ?? sizes.md
  })
</script>
